import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const RCsortChange = listeners["sort-change"] || function () { };

  const tableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "视频名称",
      prop: "videoName",
      minWidth: "200",
      showOverflowTooltip: true
    },
    {
      label: "授课人",
      prop: "lecturerName",
      minWidth: "100"
    },
    {
      label: "视频分类",
      prop: "categoryName",
      minWidth: "150"
    },
    {
      label: "展示终端",
      prop: "displayTypeName",
      minWidth: "140"
    },
    {
      label: "总学习人数",
      prop: "learnTotalCount",
      minWidth: "100"
    },
    {
      label: "已完成学习人数",
      prop: "learnCompleteCount",
      minWidth: "100",
      showOverflowTooltip: true,
    },
    {
      label: "正在学习人数",
      prop: "studyCount",
      minWidth: "100",
      showOverflowTooltip: true,
    },
    {
      label: "实际播放量",
      prop: "playNum",
      minWidth: "80",
      sortable: "custom",
    },
    {
      label: "播放量基数",
      prop: "playBaseNum",
      minWidth: "80",
      sortable: "custom",
    },
    // {
    //   label: "收藏人数",
    //   prop: "collectCount",
    //   minWidth: "80",
    //   showOverflowTooltip: true
    // },
  ];
  if (args.props.userType == -1 && args.props.deptLevelCode == "001") {
    tableConfig.splice(2, 0, {
      label: "所属分院",
      prop: "academyName",
      width: "120",
      showOverflowTooltip: true
    });
  }
  return (
    <List
      {...args}
      talbeCols={tableConfig}
      onSelectionChange={RCSelectionChange}
      onSortChange={RCsortChange}
    />
  );
};

export default Table;
